import { SectionResult } from '../../../../types';
import SectionCompetitorResults from '../../shared/SectionCompetitorResults';
import SectionMessage from '../../shared/SectionMessage';
import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import { SectionProps } from '../../types';
import './DataVisualization.less';
import React from 'react';
import LegacyResult from './LegacyResult';
import Result from './Result';

export default function PageObjectsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    let renderResultComponent: (result: SectionResult) => React.ReactNode = () => null;

    if (result.page_objects.size_by_type) {
        renderResultComponent = (result) => <Result pageObjects={result.page_objects} />;
    } else {
        renderResultComponent = (result) => <LegacyResult pageObjects={result.page_objects} />;
    }

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={1}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {renderResultComponent(result)}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={1}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
